/**
 * AI CONTEXT
 * Purpose: compact header row for attendance category sections with icon + count.
 * Used by: attendance section renderers and exception list grouping.
 * Inputs: section type and item count.
 * Refactor: move icon/type mapping to shared constant module.
 */
import { UserOutlined, WarningOutlined } from "@ant-design/icons"

import MakeupsIcon from "#assets/makeupsIcon.svg?react"
import PlannedAbsencesIcon from "#assets/plannedAbsencesIcon.svg?react"
import TryoutsIcon from "#assets/tryoutsIcon.svg?react"
import Counter from "#blocks/Counter"
import Flex from "#blocks/Flex"
import { useThemeContext } from "#contexts/ThemeContextProvider"
import { camelToWords } from "#utils/textFormatters"

const AttendanceSectionHeader = ({
  type,
  count = 0,
}: {
  type:
    | "students"
    | "tryouts"
    | "makeups"
    | "assistants"
    | "plannedAbsences"
    | "exceptions"
  count: number
}) => {
  const { iconColors, border } = useThemeContext()

  const ICONS_BY_FIELD = {
    students: <UserOutlined style={{ fontSize: 10 }} />,
    tryouts: <TryoutsIcon fill={iconColors.tryouts} />,
    makeups: <MakeupsIcon fill={iconColors.makeups} />,
    assistants: <UserOutlined style={{ fontSize: 10 }} />,
    plannedAbsences: <PlannedAbsencesIcon fill={iconColors.plannedAbsences} />,
    exceptions: (
      <WarningOutlined style={{ fontSize: 10, color: iconColors.exceptions }} />
    ),
  }

  return (
    <Flex
      gap={8}
      style={{
        borderRadius: 20,
        backgroundColor: border,
        padding: "3px 36px 3px 10px",
        fontWeight: "bold",
        fontSize: 10,
        marginBottom: 2,
        color: iconColors[type],
        alignItems: "center",
        justifyContent: "space-between",
        width: "100%",
      }}
    >
      <Flex gap={6} style={{ alignItems: "center" }}>
        {ICONS_BY_FIELD[type]}
        {camelToWords(type)}
      </Flex>
      <Flex style={{ marginTop: 2 }}>
        <Counter value={count} />
      </Flex>
    </Flex>
  )
}

export default AttendanceSectionHeader
